import { LineItemErrorCodes } from 'sonata-static-storage/lib/schemas/campaign/lineItemError.schema';

import type { MessageDescriptor } from 'react-intl';

const CREATIVE_VALIDATION_MESSAGE: MessageDescriptor = {
  defaultMessage: '{entity} saved, but creative validation failed',
  id: 'MTFSettings.header.savedWithCreativeValidationError'
};

export const BIDDER_SYNC_ERROR_MESSAGE: MessageDescriptor = {
  defaultMessage: '{entity} saved, but synchronisation with the bidder failed',
  id: 'MTFSettings.header.savedWithBidderSyncError'
};

const SYNC_ERROR_MESSAGES: Record<string, MessageDescriptor> = {
  [LineItemErrorCodes.DOOH_ADVERTISER_FAIL]: {
    defaultMessage: '{entity} saved, but synchronisation with the DOOH media advertiser failed',
    id: 'MTFSettings.header.savedWithDoohAdvertiserSyncError'
  },
  [LineItemErrorCodes.DTO_BUILD_FAIL]: BIDDER_SYNC_ERROR_MESSAGE,
  [LineItemErrorCodes.RBA_NOTIFY_FAIL]: BIDDER_SYNC_ERROR_MESSAGE,
  [LineItemErrorCodes.RBA_SOCKET_TIMEOUT]: BIDDER_SYNC_ERROR_MESSAGE,
  [LineItemErrorCodes.RBA_VALIDATION_ERROR]: BIDDER_SYNC_ERROR_MESSAGE,
  [LineItemErrorCodes.TQ_NOTIFY_FAIL]: CREATIVE_VALIDATION_MESSAGE,
  [LineItemErrorCodes.TQ_PREP_FAIL]: CREATIVE_VALIDATION_MESSAGE,
  [LineItemErrorCodes.TQ_VALIDATION_FAIL]: CREATIVE_VALIDATION_MESSAGE
};

type ApiErrorDetail = { code?: string };
type SavedEntityApiError = {
  body?: ApiErrorDetail[] | { error?: ApiErrorDetail };
};

function getApiErrorCode(error: unknown): string | undefined {
  const { body } = (error as SavedEntityApiError) ?? {};
  return (Array.isArray(body) ? body[0] : body?.error)?.code;
}

/**
 * Returns the message naming the service that failed when the entity was persisted but a downstream
 * service rejected it, or undefined when the entity was not saved at all.
 */
export function getSavedEntitySyncErrorMessage(error: unknown): MessageDescriptor | undefined {
  const code = getApiErrorCode(error);
  return code ? SYNC_ERROR_MESSAGES[code] : undefined;
}
